module.exports = __webpack_public_path__ + "img/zikoo_logo.3df95d83.png";